import React from "react";
import Image from "../Image";
export default function HomeFooter() {
  return (
    <div>
      {/* Footer section start */}
      <footer className="site-footer">
        <div className="max-width">
          <div className="footer_logo">
            <Image
              src="/images/kfintech-monochrome.svg"
              alt="footer-logo"
              style={{
                height: "60px",
                opacity: "0.8",
              }}
            // style="height: 60px; opacity: 0.8;"
            />
            <p>
              KFintech serves the mission-critical needs of asset managers with
              clients spanning mutual funds, AIFs (alternative investments),
              pension, wealth managers and corporates in India and abroad. The
              company provides SaaS based end-to-end transaction management,
              channel management, compliance solutions, data analytics and
              various other digital services to asset managers across segments,
              as well as outsourcing services for global players.
            </p>
          </div>
          <div className="footer_links">
            <div className="footer_links_info">
              <ul>
                <li>
                  <h5>ABOUT US</h5>
                </li>
                <li>
                  <a href="https://www.kfintech.com/about-us" target="_blank" rel="noreferrer">
                    About KFintech
                  </a>
                </li>
                <li>
                  <a href="https://careers.kfintech.com/" target="_blank" rel="noreferrer">
                    Careers
                  </a>
                </li>
                <li>
                  <a href="https://www.kfintech.com/contact-us" target="_blank" rel="noreferrer">
                    Contact Us
                  </a>
                </li>
              </ul>
              <ul>
                <li>
                  <h5>MUTUAL FUND SOLUTIONS</h5>
                </li>
                <li>
                  <a
                    href="https://mfs.kfintech.com/mfs/distributor/distributor_Login.aspx"
                    target="_blank" rel="noreferrer"
                  >
                    Distributor Solutions
                  </a>
                </li>
                <li>
                  <a
                    href="https://cpupload.kfintech.com/ChannelServices/CP_Login.aspx"
                    target="_blank" rel="noreferrer"
                  >
                    Channel Partner Solutions
                  </a>
                </li>
                <li>
                  <a href="https://mfs.kfintech.com/investor/" target="_blank" rel="noreferrer">
                    Mutual Fund Investor Solutions
                  </a>
                </li>
                <li>
                  <a href="https://mfs.kfintech.com/econnect" target="_blank" rel="noreferrer">
                    Korp Connect
                  </a>
                </li>
                <li>
                  <a
                    href="https://cpupload.kfintech.com/ChannelServices/RIA_Login.aspx"
                    target="_blank" rel="noreferrer"
                  >
                    RIA Solutions
                  </a>
                </li>
                <li>
                  <a
                    href="https://mfs.kfintech.com/Mfsalternative"
                    target="_blank" rel="noreferrer"
                  >
                    AIF Investors
                  </a>
                </li>
                <li>
                  <a
                    href="https://fundswatch.kfintech.com/amcservices/"
                    target="_blank" rel="noreferrer"
                  >
                    AMC Solutions
                  </a>
                </li>
                <li>
                  <a
                    href="https://mfs.kfintech.com/FinancialServices"
                    target="_blank" rel="noreferrer"
                  >
                    Financial Solutions
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer_links_info">
              <ul>
                <li>
                  <h5>CORPORATE REGISTRY</h5>
                </li>
                <li>
                  <a href="https://karisma.kfintech.com/" target="_blank" rel="noreferrer">
                    Karisma
                  </a>
                </li>
                <li>
                  <a href="https://evoting.kfintech.com/" target="_blank" rel="noreferrer">
                    Evoting
                  </a>
                </li>
                <li>
                  <a href="https://kcas.kfintech.com/fintraks/" target="_blank" rel="noreferrer">
                    Fintraks
                  </a>
                </li>
                <li>
                  <a href="https://kprism.kfintech.com/" target="_blank" rel="noreferrer">
                    Kprism
                  </a>
                </li>
                <li>
                  <a href="https://kreation.kfintech.com/" target="_blank" rel="noreferrer">
                    Kreation
                  </a>
                </li>
              </ul>
              <ul>
                <li>
                  <h5>NATIONAL PENSION SCHEME</h5>
                </li>
                <li>
                  <a href="https://nps.kfintech.com/" target="_blank" rel="noreferrer">
                    NPS
                  </a>
                </li>
                <li>
                  <a href="https://enps.kfintech.com/" target="_blank" rel="noreferrer">
                    eNPS
                  </a>
                </li>
                <li>
                  <a href="https://cra.kfintech.com/" target="_blank" rel="noreferrer">
                    CRA
                  </a>
                </li>
              </ul>
              <ul>
                <li>
                  <h5>GLOBAL BUSINESS SOLUTIONS</h5>
                </li>
                <li>
                  <a
                    href="https://globalbusinessservices.kfintech.com/gbs/mortgage-outsourcing-services"
                    target="_blank" rel="noreferrer"
                  >
                    Mortgage Solutions
                  </a>
                </li>
                <li>
                  <a
                    href="https://globalbusinessservices.kfintech.com/gbs/Transfer-Agency-Services/"
                    target="_blank" rel="noreferrer"
                  >
                    MFTA Solutions
                  </a>
                </li>
                <li>
                  <a
                    href="https://globalbusinessservices.kfintech.com/gbs/Legal-process-outsourcing-services/"
                    target="_blank" rel="noreferrer"
                  >
                    Legal Solutions
                  </a>
                </li>
                <li>
                  <a
                    href="https://globalbusinessservices.kfintech.com/gbs/Finance-Accounting-fa-outsourcing-Services/"
                    target="_blank" rel="noreferrer"
                  >
                    Finance &amp; Accounting Solutions
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer_links_info">
              <ul>
                <li>
                  <h5>OTHER SOLUTIONS</h5>
                </li>
                <li>
                  <a
                    href="https://www.kfintech.com/gfs-malaysia/"
                    target="_blank" rel="noreferrer"
                  >
                    GFS
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.kfintech.com/private-wealth-management/"
                    target="_blank" rel="noreferrer"
                  >
                    PWM
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.kfintech.com/portfolio-management-services/"
                    target="_blank" rel="noreferrer"
                  >
                    PMS
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.kfintech.com/alternate-investment-fund/"
                    target="_blank" rel="noreferrer"
                  >
                    AIF
                  </a>
                </li>
              </ul>
              <ul>
                <li>
                  <h5>LEGAL &amp; PRIVACY</h5>
                </li>
                <li>
                  <a
                    href="https://www.kfintech.com//terms-of-use/"
                    target="_blank" rel="noreferrer"
                  >
                    Terms of Use
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.kfintech.com//privacy-policy/"
                    target="_blank" rel="noreferrer"
                  >
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.kfintech.com//qrta-guidelines-of-sebi/"
                    target="_blank" rel="noreferrer"
                  >
                    QRTA SEBI Guidelines
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.kfintech.com//disclosures/"
                    target="_blank" rel="noreferrer"
                  >
                    Disclosures
                  </a>
                </li>
              </ul>
              <ul className="footer_contact">
                <li>
                  <h5>GET IN TOUCH</h5>
                </li>
                <li className="footer_contact_tel">
                  <a href="tel:+91-40-67162222" target="_blank" rel="noreferrer">
                    <Image src="/images/phone.svg" alt="icon" />
                    +91-40-67162222
                  </a>
                  /{" "}
                  <a href="tel:040-7961 1000" target="_blank" rel="noreferrer">
                    7961 1000
                  </a>
                </li>
                <li className="footer_contact_tel">
                  <a href="tel:18003094034" target="_blank" rel="noreferrer">
                    <Image src="/images/phone.svg" alt="icon" />
                    MFS - 18003094034
                  </a>
                  
                </li>
                <li className="footer_contact_tel">
                  <a href="tel:18003094001" target="_blank" rel="noreferrer">
                    <Image src="/images/phone.svg" alt="icon" />
                    RIS - 18003094001
                  </a>
                </li>
                <li className="footer_contact_tel">
                  <a href="tel:18005716677" target="_blank" rel="noreferrer">
                    <Image src="/images/phone.svg" alt="icon" />
                    Distributor - 18005716677
                  </a>
                  
                </li>
                <li className="footer_contact_tel">
                  <a href="tel:18002081516" target="_blank" rel="noreferrer">
                    <Image src="/images/phone.svg" alt="icon" />
                    NPS - 18002081516
                  </a>
                </li>
                <li></li>
                <li>
                  <a href="mailto:einward.ris@kfintech.com" target="_blank" rel="noreferrer">
                    <Image src="/images/mail.svg" alt="icon" />
                    einward.ris@kfintech.com
                  </a>
                </li>
                <li>
                  <a
                    href="mailto:investorsupport.mfs@kfintech.com"
                    target="_blank" rel="noreferrer"
                  >
                    <Image src="/images/mail.svg" alt="icon" />
                    investorsupport.mfs@kfintech.com
                  </a>
                </li>
                <li>
                  <a
                    href="mailto:kfinkart.support@kfintech.com"
                    target="_blank" rel="noreferrer"
                  >
                    <Image src="/images/mail.svg" alt="icon" />
                    kfinkart.support@kfintech.com
                  </a>
                </li>
                <li>
                  <a
                    href="mailto:kfinkart.distsupport@kfintech.com"
                    target="_blank" rel="noreferrer"
                  >
                    <Image src="/images/mail.svg" alt="icon" />
                    kfinkart.distsupport@kfintech.com
                  </a>
                </li>
                {/* <li>
                  <a href="mailto:reachus@kfintech.com" target="_blank" rel="noreferrer">
                    <Image src="/images/mail.svg" alt="icon" />
                    reachus@kfintech.com
                  </a>
                </li> */}
              </ul>
            </div>
          </div>
        </div>
        <div className="footer_bottom">
          <p className="footer_copyright footer_copyright_desktop">
            © Copyright KFintech 2022 | All Rights Reserved.
          </p>
          <ul>
            <li>
              <h5>CONNECT WITH US</h5>
            </li>
            <li className="footer_social_links">
              <a href="https://twitter.com/weKFintech" target="_blank" rel="noreferrer">
                <Image src="/images/twitter.svg" alt="twitter" />
              </a>
              <a href="https://www.instagram.com/wekfintech" target="_blank" rel="noreferrer">
                <Image src="/images/instagram.svg" alt="instagram" />
              </a>
              <a href="https://www.facebook.com/weKFintech/" target="_blank" rel="noreferrer">
                <Image src="/images/facebook.svg" alt="facebook" />
              </a>
              <a
                href="https://in.linkedin.com/company/wekfintech"
                target="_blank" rel="noreferrer"
              >
                <Image src="/images/linkedin.svg" alt="linkedin" />
              </a>
              <a
                href="https://www.youtube.com/channel/UCgoNI8dZ033EqXZ7IqQ2fVw"
                target="_blank" rel="noreferrer"
              >
                <Image src="/images/youtube.svg" alt="youtube" />
              </a>
            </li>
          </ul>
          <div className="footer_here">
            <p>
              Here <span>For</span> You
            </p>
          </div>
          <p className="footer_copyright footer_copyright_mobile">
            © Copyright KFintech 2022 | All Rights Reserved.
          </p>
        </div>
      </footer>
      {/* Footer section start */}
    </div>
  );
}
